import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const catalogRBAC = {
  pageID: '3f18216f344ff78c121235c77fee937e',
  elementID: {
    ViewCatalog: '4912f9ca0c0a284450f7238a498de7b8',
    CreateCatalog: '8c9b80e590ce5efabf772e0dafc6bb1f',
    EditCatalog: '66b5416fdd8e949a957fdf9d22e40547',
    DeleteCatalog: 'bcb7f2e501764cca6967b3957c241b08',
    EditBackground: 'f841a95bd351f6d11352572e816fa0e2',
    BulkUploadCatalog: '25dc2f6c33d62639dd0ce16ca0fc86ea',
  },
} as const

export const useRBACCatalogPage = createUseRBAC(catalogRBAC.elementID)

export type UseRBACCatalogPageType = ReturnType<typeof useRBACCatalogPage>
